import { http } from '@/http/axios.js'
export function getImgCodeAPI(params) {
  return http({
    url: '/api/company/basic/passport/misc/captcha',
    method: 'get',
    params
  })
}
